<template>
    <div class="animated fadeIn">
        <spinner v-if="group.loading" />
        <!-- Add usergroup modal -->
        <b-modal
            v-if="group.name"
            lazy
            title="Add group"
            :visible="modalVisible"
            ref="addGroupMemberModal"
            size="md"
            :ok-only="true"
            ok-title="Close"
            hide-footer
            modal-class="card-body"
            :body-class="['no-body']"
        >
            <AddGroupMemberCard
                v-if="group.name"
                list_type="user"
                member_type="user"
                :context="group"
                context_type="group"
                :entities_present="groupmembers"
            />
        </b-modal>
        <b-row v-if="!group.loading">
            <b-col sm="12" md="4">
                <b-card>
                    <div slot="header">&nbsp; {{ $t('label.group') }}</div>

                    <b-form-group>
                        <label>{{ $t('label.displayname') }}</label>
                        <b-form-input
                            type="text"
                            :placeholder="$t('label.displayname')"
                            v-model="group.display_name"
                            :disabled="!canManageGroup"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <label>{{ $t('label.name') }}</label>
                        <b-form-input
                            disabled
                            type="text"
                            :placeholder="$t('label.name')"
                            v-model="group.name"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <label>{{ $t('label.description') }}</label>
                        <b-textarea
                            :placeholder="$t('label.description')"
                            v-model="group.description"
                            :disabled="!canManageGroup"
                            :rows="2"
                        ></b-textarea>
                    </b-form-group>

                    <b-form-group>
                        <label>{{ $t('label.grouptype') }}</label>
                        <multiselect
                            label="name"
                            :disabled="!canManageGroup"
                            track-by="id"
                            v-model="group.grouptype"
                            @input="groupTypeChanged"
                            :options="grouptypes"
                            placeholder
                            :select-label="$t('label.clickToChoose')"
                        />
                    </b-form-group>

                    <b-form-group v-if="loggedInUser.role.rank < 30">
                        <label>
                            Invisible for consumers?
                            {{ group.is_visible }}
                        </label>
                        <b-form-group>
                            <label class="switch switch-success">
                                <input
                                    type="checkbox"
                                    class="switch-input"
                                    v-model="group.is_hidden"
                                />
                                <span class="switch-slider"></span>
                            </label>
                        </b-form-group>
                    </b-form-group>

                    <div slot="footer">
                        <b-button
                            type="submit"
                            size="sm"
                            variant="success"
                            @click="group.save()"
                        >
                            <i
                                class="fa fa-dot-circle-o"
                                v-if="!group.saving"
                            ></i>
                            <i
                                class="fa fa-spinner fa-spin"
                                v-if="group.saving"
                            ></i>
                            {{ $t('label.save') }} </b-button
                        >&nbsp;
                    </div>
                </b-card>
            </b-col>
            <b-col sm="12" md="6">
                <ListGroupCard
                    :title="$t('label.members')"
                    :model="groupmembers"
                    :fetchOnInit="false"
                    filterKey="member.name"
                >
                    <div slot="cardHeader">
                        {{ $t('label.members') }} - ({{ groupmembers.length }})
                        <b-button
                            v-if="false"
                            variant="success"
                            :disabled="!comp_AbleToEdit"
                            class="float-right"
                            size="sm"
                            @click="showModal"
                        >
                            <i class="fa fa-users" />
                            {{ $t('label.addMember') }}
                        </b-button>
                    </div>
                    <b-list-group-item
                        action
                        class="d-flex justify-content-between align-items-center"
                        slot="modelContainer"
                        slot-scope="member"
                        @mouseover="activeGroup = member.item.id"
                        v-if="member.item.member !== null"
                    >
                        <router-link :to="getUserLink(member.item.member)">{{
                            member.item.member.name
                        }}</router-link>
                        <div
                            class="pull-right"
                            v-if="activeGroup == member.item.id"
                        >
                            <b-button
                                size="sm"
                                variant="danger"
                                v-if="canManageGroupMembers"
                                @click="member.item.delete()"
                                >{{ $t('text.removeMember') }}</b-button
                            >
                        </div>
                        <div
                            class="pull-right"
                            v-if="activeGroup != member.item.id"
                        >
                            <b-button size="sm" class="d-none">&nbsp;</b-button>
                        </div>
                    </b-list-group-item>
                </ListGroupCard>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// TODO: This needs fixing!
import GenericModel from '@/models/GenericModel'
import GenericCollection from '@/models/GenericCollection'
import ListGroupCard from '@/components/ListGroupCard'

// import Spinner from 'vue-spinner-component/src/Spinner'
import AddGroupMemberCard from './__partials__/AddGroupMemberCard'

import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
    components: {
        // Spinner,
        ListGroupCard,
        AddGroupMemberCard,
    },
    props: {},
    data() {
        return {
            group: new GenericModel({
                id: this.$route.params.groupId,
            }),
            groupTypes: new GenericCollection().setResourceName('grouptypes'),
            groupmembers: new GenericCollection().setResourceName(
                'groupmembers'
            ),
            modalVisible: false,
            activeGroup: '',
            loggedInUser: this.$store.getters['auth/user'],
        }
    },
    created() {
        this.groupInit(this.group)
        this.groupTypes.fetch()
    },
    methods: {
        groupInit(group) {
            group.setResourceName('groups')
            group.setIncludes('grouptype,users')
            let res = group.fetch()
            group.on('fetch', this.onFetchResponse)

            return res
        },
        onFetchResponse() {
            this.loadGroupmembers()
            if (_.isEqual('response.error.response.response.status', 404)) {
                this.$router.push({
                    name: 'Page404',
                })
            }
        },

        groupTypeChanged(grouptype) {
            this.group.set('grouptype_id', null)
            this.group.set('grouptype_id', grouptype.id)
        },

        loadGroupmembers() {
            let group = this.group
            let groupmembers = this.groupmembers
            groupmembers.setResourceName('groupmembers')
            groupmembers.setPerPage(10000)
            groupmembers.setIncludes('member')
            groupmembers.setFilter({
                group_id: group.id,
                member_type: 'User',
            })

            groupmembers.fetch().then(this.sortMembers)
        },
        showModal() {
            this.modalVisible = true
            let ref = this.$refs.addGroupMemberModal
            if (typeof ref != 'undefined') {
                ref.show()
            }
            return true
        },
        hideModal() {
            this.modalVisible = false
            let ref = this.$refs.addGroupMemberModal
            if (typeof ref != 'undefined') {
                ref.hide()
            }
        },
        sortMembers() {
            return this.groupmembers.models.sort((a, b) => {
                if (a.member === null || b.member === null) {
                    return false
                }
                return a.member.name.localeCompare(b.member.name)
            })
        },

        getUserLink(user) {
            return (
                '/organization/' +
                this.$route.params.orgId +
                '/users/' +
                user.id
            )
        },
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            isManager: 'auth/isManager',
            isCompanyAdmin: 'auth/isCompanyAdmin',
            isGlobalAdmin: 'auth/isGlobalAdmin',
        }),

        canManageGroup() {
            // If user is Global operator
            if (this.isGlobalAdmin) {
                return true
            }

            // Return false as default
            return false
        },

        canManageGroupMembers() {
            // If user is Global operator
            if (this.isGlobalAdmin) {
                return true
            }

            // If the user is a company-admin for current groups company
            if (
                this.user.company_id == this.group.company_id &&
                this.isCompanyAdmin
            ) {
                return true
            }

            // Return false as default
            return false
        },

        grouptypes() {
            if (this.groupTypes.loading) {
                return []
            }

            return this.groupTypes.models.map(grouptype => {
                return {
                    id: grouptype.id,
                    name: grouptype.name,
                }
            })
        },
        comp_AbleToEdit() {
            let loggedInUser = this.$store.getters['auth/user']
            let isGlobalAdmin = loggedInUser.role.rank <= 20
            let isCompanyAdmin =
                loggedInUser.role.rank <= 30 && loggedInUser.role.rank > 20
            let isManager =
                loggedInUser.role.rank <= 50 && loggedInUser.role.rank > 30

            let haveAccessToGroup =
                this.loggedInUser.groups.filter(g => {
                    return g.id === this.group.id
                }).length > 0
            let result =
                isGlobalAdmin ||
                (isCompanyAdmin &&
                    this.group.company_id == this.loggedInUser.company_id) ||
                (isManager && haveAccessToGroup)
            return result
        },

        /*
    departmentsArray() {
      return this.departments.models.map(department => {
        return {
          id: department.id,
          name: department.name
        };
      });
    },
    rolesArray() {
      return this.roles.models
        .map(role => {
          return {
            id: role.id,
            name: role.name,
            rank: role.rank
          };
        })
        .filter(role => role.rank > this.$store.state.auth.user.role.rank);
    }*/
    },
}
</script>
